(function () {
  var TIMEOUT_MS = 8000;

  function getSectionRoot(sectionId) {
    return document.getElementById('shopify-section-' + sectionId);
  }

  function fullNavigate(url) {
    window.location.assign(url);
  }

  function replaceSection(sectionId, html, nextUrl) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newSection = doc.getElementById('shopify-section-' + sectionId);
    var current = getSectionRoot(sectionId);
    if (!newSection || !current) {
      return false;
    }
    current.replaceWith(newSection);
    if (window.history && window.history.pushState) {
      window.history.pushState({ fabricSwitch: true }, '', nextUrl);
    }
    if (typeof window.initProductInfo === 'function') {
      window.initProductInfo();
    }
    if (typeof window.pdpApplySizeFit === 'function') {
      window.pdpApplySizeFit();
    }
    bindFabricSwitcher();
    if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
      Shopify.PaymentButton.init();
    }
    return true;
  }

  function fetchSection(url, sectionId) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    var fetchUrl = url + sep + 'section_id=' + encodeURIComponent(sectionId);
    var timer = null;
    var fetchPromise = fetch(fetchUrl, controller ? { signal: controller.signal } : undefined).then(function (res) {
      if (!res.ok) throw new Error('bad status');
      return res.text();
    });
    var timeoutPromise = new Promise(function (_, reject) {
      timer = setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error('timeout'));
      }, TIMEOUT_MS);
    });
    return Promise.race([fetchPromise, timeoutPromise]).then(
      function (html) {
        clearTimeout(timer);
        return html;
      },
      function (err) {
        clearTimeout(timer);
        throw err;
      }
    );
  }

  function onFabricClick(event) {
    var btn = event.currentTarget;
    var root = btn.closest('[data-fabric-switcher]');
    if (!root || btn.disabled || btn.classList.contains('is-active')) return;
    var url = btn.getAttribute('data-fabric-url');
    var sectionId = root.getAttribute('data-section-id');
    if (!url || !sectionId) return;
    root.classList.add('is-loading');
    fetchSection(url, sectionId)
      .then(function (html) {
        var ok = replaceSection(sectionId, html, url);
        if (!ok) fullNavigate(url);
      })
      .catch(function () {
        fullNavigate(url);
      });
  }

  function bindFabricSwitcher() {
    var roots = document.querySelectorAll('[data-fabric-switcher]');
    roots.forEach(function (root) {
      root.querySelectorAll('.fabric-switcher__item').forEach(function (btn) {
        btn.removeEventListener('click', onFabricClick);
        btn.addEventListener('click', onFabricClick);
      });
    });
  }

  window.bindFabricSwitcher = bindFabricSwitcher;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFabricSwitcher);
  } else {
    bindFabricSwitcher();
  }

  document.addEventListener('variant:change', bindFabricSwitcher);

  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();
